import 'babel-polyfill';
import 'utils/check-fetch';
import 'whatwg-fetch';
import 'utils/pointer-events-polyfill';
import 'scss/app.scss';
import 'modernizr';
import pretend from 'pretender/main';
import React from 'react';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { addLocaleData } from 'react-intl';
import { Provider } from 'react-intl-redux';
import { makeStore, getStore } from 'store';
import checkCacheVersion from 'utils/check-cache-version';

import setIntlPolyfill from 'utils/intl-polyfill';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import nl from 'react-intl/locale-data/nl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/fr';
import 'intl/locale-data/jsonp/nl';

import AppRouter from './app-router';
import LoadCookieConsentScript from './components/load-cookie-consent';
import { LOAD_COOKIE_CONSENT } from './config/cookie-consent';

if ('false' === 'true') { // eslint-disable-line
  pretend();
}

checkCacheVersion();

setIntlPolyfill();
addLocaleData([...en, ...fr, ...nl]);

makeStore();

const store = getStore();
const history = syncHistoryWithStore(browserHistory, store);
const elem = document.getElementById('app');

function onUpdateRouter() {
  // scroll to the top of each new page
  jQuery(window).scrollTop(0);
}

function shouldCookieConsentInject() {
  if (!LOAD_COOKIE_CONSENT) return false;

  const currentLocation = history.getCurrentLocation();

  if (!currentLocation) return true;

  const { pathname } = currentLocation;

  // The cookie consent should not be injected on these separate routes for server side rendering
  if (pathname.includes('quote-view') || pathname.includes('system-view')) {
    return false;
  }

  return true;
}

ReactDOM.render(
  <Provider store={store}>
    <div>
      <AppRouter
        history={history}
        onUpdateRouter={onUpdateRouter}
      />
      {shouldCookieConsentInject() &&
        <LoadCookieConsentScript />
      }
    </div>
  </Provider>,
  elem,
);



// WEBPACK FOOTER //
// ./js/main.jsx